import * as React from "react";
import { CaseRunClient, ClientResources, GenerateSampleJobResponse } from "@app/api2/api";
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "@/components/bp/bp-ui";
import { BPBoxWithHeader } from "@app/components/React/Common/BPBoxWithHeader";
import { InfoBox } from "@app/components/React/Common/InfoBox";

interface GenerateSampleResultsProps {
    labId: number;
    caseId: number
    caseRunId: number;
    forPrint?: boolean;
}
interface GenerateSampleResultsState {
    jobresponse: GenerateSampleJobResponse;
    loading: boolean,
}

export class GenerateSampleResults extends React.Component<GenerateSampleResultsProps, GenerateSampleResultsState> {
    client: CaseRunClient = new CaseRunClient();
    translationsContext: React.Context<ClientResources>;

    constructor(props, context) {
        super(props, context);
        this.state = { jobresponse: null, loading: false };
        
    }

    async componentDidMount(): Promise<void> {
        let data = await this.client.getGenSampleResults(this.props.labId, this.props.caseId, this.props.caseRunId);
        this.setState({ ...this.state, jobresponse: data })
    }

    render() {
        const evSystems = this.state.jobresponse?.evidence.flatMap(x => x.systems)
        const rows = evSystems?.map(sys => {
            return {
                locus: sys.systemName,
                evidName: this.state.jobresponse.evidence[0].name,
                evidenceAlleles: this.state.jobresponse.evidence[0].systems.find(s => s.systemName == sys.systemName)?.alleles.map(a => a.value),
                evidenceHeights: this.state.jobresponse.evidence[0].systems.find(s => s.systemName == sys.systemName)?.alleles.map(a => a.height),
                references: this.state.jobresponse.reference.map(ref => {
                    return {
                        refName: ref.name,
                        alleles: ref.systems.find(rs => rs.systemName == sys.systemName)?.alleles.map(a => a.value)
                    }
                })
            }
        })

        const evidAlleleMaxCount = Math.max(...evSystems?.map(s => { return s.alleles.length; }) ?? [2]);
        const referenceCount = this.state.jobresponse?.reference.length;



        return (<div>
            <ParameterEstimates forPrint={this.props.forPrint} model={this.state.jobresponse}></ParameterEstimates>
            <Table definition className="sentry-hits-details">
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell />
                        <TableHeaderCell colSpan={evidAlleleMaxCount*2}>{window.translation.common.evidence}</TableHeaderCell>
                        {[...Array(referenceCount).keys()].map(x => {
                            return (
                                <TableHeaderCell colSpan={2}>{this.state.jobresponse?.reference[x].name}</TableHeaderCell>
                            )
                        })}
                    </TableRow>
                    <TableRow>
                        <TableHeaderCell></TableHeaderCell>
                        {[...Array(evidAlleleMaxCount).keys()].map(x => {
                            return (<>
                                <TableHeaderCell key={`cl${x}`}>{`Al${x + 1}`}</TableHeaderCell>
                                <TableHeaderCell key={`ch${x}`}>{`He${x + 1}`}</TableHeaderCell>
                            </>
                            )
                        })}
                        {[...Array(referenceCount).keys()].map(x => {
                            return (<>
                                <TableHeaderCell>Al1</TableHeaderCell>
                                <TableHeaderCell>Al2</TableHeaderCell>
                            </>)
                        })}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {rows?.map((m, i) => (
                        <TableRow key={m.locus}>
                            <TableCell>
                                {m.locus}
                            </TableCell>
                            {[...Array(evidAlleleMaxCount).keys()].map(x => {
                                return (<>
                                    <TableCell key={`cll${x}`}>
                                        {m.evidenceAlleles[x]}
                                    </TableCell>
                                    <TableCell key={`chh${x}`}>
                                        {m.evidenceHeights[x]}
                                    </TableCell>
                                </>
                                )
                            })}
                            {m.references.map(x => {
                                return (<>
                                    <TableCell>
                                        {x.alleles[0]}
                                    </TableCell>
                                    <TableCell>
                                        {x.alleles[1]}
                                    </TableCell>
                                </>
                                )
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

        </div>

        );
    }
}

function ParameterEstimates(props: { forPrint: boolean, model: GenerateSampleJobResponse }) {
    if (props.model == null)
        return null;
    return <BPBoxWithHeader forPrint={props.forPrint} header={window.translation.common.parameters}><InfoBox
        forPrint={props.forPrint}
        header={''}
        items={[
            { label: 'rho', description: props.model.rho, width: 6 },
            { label: 'tau', description: props.model.tau, width: 6 },
            { label: 'beta', description: props.model.beta, width: 6 },
            { label: 'xiBW', description: props.model.xiBW, width: 6 },
            { label: 'xiFW', description: props.model.xiFW, width: 6 },
            ...props.model.mx.map((m, idx) => { return { label: `mx${idx}`, description: m }; })
        ]} /></BPBoxWithHeader>
}